import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const CampusOthers = (props) => {
    const width = props.width ? props.width + 'px' : '70px';
    const height = props.height ? props.height + 'px' : '35px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 70 35"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path d="M29.234 14.8179L24.1152 26.7836H27.5375L30.5562 19.7264L33.575 26.7836H36.9972L31.8784 14.8179H29.234Z" />
            <path d="M30.6684 0C27.1101 0 24.2129 2.8908 24.2129 6.44124C24.2129 9.99168 27.1053 12.8825 30.6684 12.8825C34.2316 12.8825 37.124 9.99168 37.124 6.44124C37.124 2.8908 34.2316 0 30.6684 0ZM30.6684 9.73947C28.8455 9.73947 27.3629 8.26012 27.3629 6.44124C27.3629 4.62237 28.8455 3.14302 30.6684 3.14302C32.4914 3.14302 33.9789 4.62237 33.9789 6.44124C33.9789 8.26012 32.4962 9.73947 30.6684 9.73947Z" />
            <path d="M14.2974 0C10.739 0 7.8418 2.8908 7.8418 6.44124C7.8418 9.99168 10.7342 12.8825 14.2974 12.8825C17.8605 12.8825 20.7529 9.99168 20.7529 6.44124C20.7529 2.8908 17.8557 0 14.2974 0ZM14.2974 9.73947C12.4744 9.73947 10.9918 8.26012 10.9918 6.44124C10.9918 4.62237 12.4744 3.14302 14.2974 3.14302C16.1203 3.14302 17.6078 4.62237 17.6078 6.44124C17.6078 8.26012 16.1251 9.73947 14.2974 9.73947Z" />
            <path d="M21.8118 14.4878H6.78125V17.626H9.81944V26.7834H12.9694V17.626H15.6285V26.7834H18.7736V17.626H21.8118V14.4878Z" />
            <path d="M53.365 4.89893C47.6629 4.89893 43.0254 9.52614 43.0254 15.2156C43.0254 20.905 47.6629 25.5322 53.365 25.5322C59.0671 25.5322 63.7046 20.905 63.7046 15.2156C63.7046 9.52614 59.0671 4.89893 53.365 4.89893ZM53.365 22.4377C49.374 22.4377 46.1268 19.1977 46.1268 15.2156C46.1268 11.2335 49.374 7.99344 53.365 7.99344C57.3559 7.99344 60.6032 11.2335 60.6032 15.2156C60.6032 19.1977 57.3559 22.4377 53.365 22.4377Z" />
            <path d="M54.551 11.4321H52.1788V14.0319H49.5781V16.3989H52.1788V18.9986H54.551V16.3989H57.1566V14.0319H54.551V11.4321Z" />
            <path d="M70 31.2168H0V35.0001H70V31.2168Z" />
        </SvgStyled>
    );
};

export default CampusOthers;
